export default "__VITE_ASSET__89a25848__"